/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const FreeshipCouponUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.FreeshipCouponUpdatePage
);
